import React from 'react'
import classnames from 'classnames'

const Label = ({ className, ...rest }) => (
  <label
    className={classnames(
      'block text-3xl text-white text-left font-medium w-full mb-8 font-ownersWide uppercase',
      className
    )}
    {...rest}
  />
)

export default Label
